'use client'
import { forwardRef } from "react"
import { type MDXEditorMethods, type MDXEditorProps } from '@mdxeditor/editor'
import Editor from "./InitializedMDXEditor";



// This is what is imported by other components. Pre-initialized with plugins, and ready
// to accept other props, including a ref.
export const ForwardRefEditor = forwardRef<MDXEditorMethods, MDXEditorProps>((props, ref) => <Editor {...props} editorRef={ref} />)


// TS complains without the following line
ForwardRefEditor.displayName = 'ForwardRefEditor'
